export const shortDur = 3e3;
export const medDur = 6e3;
export const longDur = 9e3;
export const longerDur = 12e3;
export const longestDur = 15e3;
